<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {}
    },
    methods: {},
}
</script>

<template>
    <div>
        <h4>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Abonnement</h4>
        <p>Libérez votre esprit de pilote avec notre plan d'abonnement {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} ! <strong>Bénéficiez jusqu'à 50% de réduction lorsque vous vous abonnez</strong> au rechargement mensuel de crédits—ce qui signifie plus de temps derrière le volant pour moins cher. Les crédits peuvent être utilisés pour réserver nos simulateurs de course ultra-réalistes et haut de gamme, parfaits pour vous et vos amis. De la Formule 1 aux courses GT, nos installations offrent une expérience totalement immersive avec retour Haptique.</p>
        <h4>FAQ</h4>
        <p>
            <ul>
                <li><strong>Comment fonctionne l'abonnement ?</strong> Vous achetez des crédits à un tarif réduit, jusqu'à 50% de réduction !</li>
                <li><strong>Puis-je utiliser des crédits pour des amis ?</strong> Oui, partagez l'expérience en réservant pour d'autres.</li>
                <li><strong>Les crédits expirent-ils ?</strong> Oui, utilisez-les ou perdez-les !</li>
                <li><strong>Quels simulateurs puis-je utiliser ?</strong> Vous pouvez utiliser des crédits sur n'importe quel simulateur. Vous sélectionnez simplement le montant de crédits que vous souhaitez recharger chaque mois.</li>
                <li><strong>Combien de temps dois-je garder mon abonnement actif ?</strong> Si vous annulez votre abonnement dans les 2 mois, vous serez facturé au prix fort pour les réservations que vous avez effectuées.</li>
            </ul>
        </p>
    </div>
</template>

<style lang="scss" scoped>
</style>
